module.exports = __webpack_public_path__ + "static/img/404.96b6c1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/NoPage/404.jpg
// module id = 67rV
// module chunks = 1